import { put, call, takeLatest } from "redux-saga/effects";
import { APIClient } from "../../helpers/api_helper";
import i18n from "../../i18n";
import { translateApiError } from "../../helpers/translateApiError";
import {
  updateTenantSettingsSuccess,
  updateTenantSettingsError,
  getTenantSettingsSuccess,
  getTenantSettingsError,
} from "./actions";
import { UPDATE_TENANT_SETTINGS, GET_TENANT_SETTINGS } from "./actionTypes";

const api = new APIClient();

function* updateTenantSettings({ payload: { settings } }) {
  try {
    const updateUrl = `${process.env.REACT_APP_API_BASE_URL}/api/tenant/settings`;
    const update = () =>
      api.update(updateUrl, {
        smsSettingsUID: settings.smsSettingsUID,
        smsSettingsPassword: settings.smsSettingsPassword,
      });

    const response = yield call(update);

    if (response.status_code === 200) {
      yield put(updateTenantSettingsSuccess());
    } else {
      yield put(
        updateTenantSettingsError(
          translateApiError(
            response.message,
            i18n.t("tenantSettings.errors.updateFailed")
          )
        )
      );
    }
  } catch (error) {
    yield put(
      updateTenantSettingsError(i18n.t("tenantSettings.errors.updateError"))
    );
  }
}

function* getTenantSettings() {
  try {
    const getUrl = `${process.env.REACT_APP_API_BASE_URL}/api/tenant/settings`;
    const get = () => api.get(getUrl);

    const response = yield call(get);

    if (response.status_code === 200) {
      yield put(getTenantSettingsSuccess(response.data));
    } else {
      yield put(
        getTenantSettingsError(
          translateApiError(
            response.message,
            i18n.t("tenantSettings.errors.loadFailed")
          )
        )
      );
    }
  } catch (error) {
    yield put(
      getTenantSettingsError(i18n.t("tenantSettings.errors.loadError"))
    );
  }
}

function* TenantSettingsSaga() {
  yield takeLatest(UPDATE_TENANT_SETTINGS, updateTenantSettings);
  yield takeLatest(GET_TENANT_SETTINGS, getTenantSettings);
}

export default TenantSettingsSaga;
